import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import FODApp from './components/FODApp'
import store from './store'
import { useInitApp } from './utils'

export default function App() {
	const initApp = useInitApp(store)
	initApp()

	return (
		<Provider store={store}>
			<BrowserRouter>
				<FODApp />
			</BrowserRouter>
		</Provider>
	)
}
